module.exports = `fragment hubspot_form on Contentstack_hubspot_form {
    heading
    type
    page_name
  }`;